import { addValidations } from './validation';

import { uuid, isBlank } from '../helpers/common';

class Base {
  /**
   * Create a clone of *this* but return it with the proper type.
   *
   * Common use case is to make a copy so we can then modify it before saving
   * it again.
   *
   * When working with change requests, we will often create a copy of the data
   * but assign new IDs to it so we can store it distinctly from the original.
   * In this case, pass `resetIDs=true`.
   *
   * @param {Boolean} resetIDs when true, resets UUID & id fields
   */
  inertClone(resetIDs) {
    // Need to use commonHelper.inert in addition to Object.assign to avoid also
    // copying functions with bound context (like validations/isValid). If we do, then we
    // won't be able to properly clone this object later on and we'll keep a
    // dangling ref to the old version, even after changes are made.
    const inert = JSON.parse(JSON.stringify(this));
    delete inert.validations;
    const clone = new this.constructor(inert);
    // const v = clone.validations;
    // Object.assign(clone, inert);
    // clone.validations = v; // restore validations obj
    if (resetIDs === true) {
      clone.newUUID(true);
    }
    return clone;
  }

  newUUID(resetID) {
    this._uuid = uuid();
    if (resetID === true) {
      this.id = null;
    }
  }
}

export function baseInit(obj, data, genUuid) {
  addValidations(obj);
  const initData = data && data.status && data.result ? data.result : data;
  Object.assign(obj, initData);
  if (genUuid && isBlank(obj._uuid)) {
    obj._uuid = uuid();
  }
}

export default Base;
